module.exports = __webpack_public_path__ + "img/ecommerce.category.content_image_16.086f6293.webp";